// extracted by mini-css-extract-plugin
export var actions = "_mo-d";
export var benefitCard = "_mo-a";
export var benefitIcon = "_mo-b";
export var benefitLabel = "_mo-c";
export var benefits = "_mo-9";
export var bodyText = "_mo-8";
export var closeButton = "_mo-2";
export var content = "_mo-3";
export var eyebrow = "_mo-4";
export var heading = "_mo-5";
export var image = "_mo-f";
export var imagePanel = "_mo-e";
export var modal = "_mo-0";
export var shell = "_mo-1";
export var title = "_mo-6";
export var titleOffer = "_mo-7";